angular.module('vehicle-issue')
    .component('vehicleBookingIssueList', {
        bindings: {
            bookingId: '<',
        },
        templateUrl: 'app/vehicle-issue/_booking-issues.html',
        controller: function ($scope, VehicleService, VehicleIssue, VehicleIssueConst, FilesSimpleUploadService, FilesLibrary) {
            this.VehicleService = VehicleService
            this.FilesSimpleUploadService = FilesSimpleUploadService
            this.FilesLibrary = FilesLibrary
            this.$onInit = () => {
                VehicleIssue.bookingIssues({id: this.bookingId}).$promise.then(result => this.issues = result);
            }
            $scope.$on(VehicleIssueConst.eventUpdate, () => this.$onInit())
        }
    })

// export const VehicleBookingIssueList={
//     bindings: {
//         bookingId: '<',
//     },
//     templateUrl: 'app/vehicle-issue/_booking-issues.html',
//     controller: function ($scope, VehicleService, VehicleIssue, VehicleIssueConst, FilesSimpleUploadService, FilesLibrary) {
//         this.VehicleService = VehicleService
//         this.FilesSimpleUploadService = FilesSimpleUploadService
//         this.FilesLibrary = FilesLibrary
//         this.$onInit = () => {
//             VehicleIssue.bookingIssues({id: this.bookingId}).$promise.then(result => this.issues = result);
//         }
//         $scope.$on(VehicleIssueConst.eventUpdate, () => this.$onInit())
//     }
// }
// .component('vehicleBookingIssueList', VehicleBookingIssueList)
